export const LESS_THAN_250000 = {
    value: "249 000",
    key: "clients.client.categorisation.categoryForm.form.currentAssetTypes.lessThan250",
};

export const BETWEEN_250000_1000000 = {
    value: "1 000 000",
    key: "clients.client.categorisation.categoryForm.form.currentAssetTypes.between250And1m",
};

export const MORE_THAN_1000000 = {
    value: "1 000 001",
    key: "clients.client.categorisation.categoryForm.form.currentAssetTypes.moreThan1m",
};

export default [LESS_THAN_250000, BETWEEN_250000_1000000, MORE_THAN_1000000];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/categorisation/enums/categorisationCurrentAssetTypes.js